'use strict'

/**
 * @classname ChangeContributionType
 * @classdesc 寄附行為の種別が変更されたときの制御
 */
export default class ChangeContributionType {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('.page-contributor-divide .contribution_type')
	 */
	constructor($e) {
		console.log('ChangeContributionType.constructor')
		this._$e = $e
		this._$contributorMembershipFeeWrap = this._$e.closest('.list-item').find('.contributor-membership-fee-wrap')
		this._$specifiedPurposeContributionWrap = this._$e.closest('.list-item').find('.specified-purpose-contribution')
		this._$e.on('change', () => this.onChange())
		this.onChange(0)
	}


	/**
	 * changeのコールバック
	 *
	 * @memberof ChangeContributionType
	 * @return {undefined}
	 */
	onChange(duration = 300) {
		console.log('ChangeContributionType.onChange')
		const contributionType = this._$e.find('option:selected').data('contribution-type')
		console.log(`contribution type: ${contributionType}`)
		switch (contributionType) {
			case 'unselected':
				{
					this.hideElement(this._$contributorMembershipFeeWrap, duration)
					this.hideElement(this._$specifiedPurposeContributionWrap, duration)
				}
				break
			case 'contributor-membership-fee':
				{
					this.showElement(this._$contributorMembershipFeeWrap, duration)
					this.hideElement(this._$specifiedPurposeContributionWrap, duration)
					const councilId = $('[data-select-council-id]').data('select-council-id')
					$('#council_id').val(councilId)
				}
				break
			case 'general-contribution':
				{
					this.hideElement(this._$contributorMembershipFeeWrap, duration)
					this.hideElement(this._$specifiedPurposeContributionWrap, duration)
				}
				break
			case 'specified-purpose-contribution':
				{
					this.hideElement(this._$contributorMembershipFeeWrap, duration)
					this.showElement(this._$specifiedPurposeContributionWrap, duration)
				}
				break
			default:
				console.log('contribution type is invalid')
				break
		}
	}


	/**
	 * 維持会費関連要素を表示
	 *
	 * @memberof ChangeContributionType
	 * @return {undefined}
	 */
	showElement($element, duration) {
		console.log('ChangeContributionType.showElement')
		$element
			.slideDown(duration)
			.find('.validate')
			.removeClass('ignore-validate')
	}


	/**
	 * 維持会費関連要素を非表示
	 *
	 * @memberof ChangeContributionType
	 * @return {undefined}
	 */
	hideElement($element, duration) {
		console.log('ChangeContributionType.hideElement')
		$element
			.slideUp(duration)
			.find('.validate')
			.removeClass('is-invalid')
			.addClass('ignore-validate')
			.closest('.form-group')
			.find('.error-tip')
			.removeClass('show')
			.find('.error-tip-inner')
			.html('')
	}
}
